var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpdateLogoBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6991 22.4883L44.0996 27.3506V39.9927L35.5001 44.9158L26.9006 39.9927V17.5652L40.4141 9.84623L35.5001 6.98961L21.9866 14.7086V42.7886L35.5001 50.5075L49.0136 42.7886V30.2073L66.2126 20.361V52.6348L35.5001 70.2L4.7876 52.6348V17.5652L10.9301 14.04V49.1096L35.5001 63.1496L60.0701 49.1096V30.8758L55.1561 33.6717V46.3137L35.5001 57.5579L15.8441 46.3137V11.2442L35.5001 0L52.6991 9.84623L33.0431 21.0296V36.4675L35.5001 37.9262L37.9571 36.4675V23.8862L46.5566 18.9631L52.6991 22.4883ZM63.7556 16.1673L57.6131 19.6317L51.4706 16.1673L57.6131 12.6421L63.7556 16.1673Z",
    fill: "#0675FC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateLogoBlue);
export default __webpack_public_path__ + "static/media/updateLogoBlue.4bf2d1d5fc0810b088a34e47d334cb70.svg";
export { ForwardRef as ReactComponent };